module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "current_cards"
  }, [_c('h3', {
    staticClass: "component_heading"
  }, [_vm._v(_vm._s(_vm.$t("loyalty.heading")))]), _vm._v("\n  " + _vm._s(_vm.hideAllRules()) + "\n  "), _vm._l((_vm.user.cards), function(card, cardIndex) {
    return _c('div', {
      key: cardIndex
    }, [(card.club !== 4) ? _c('div', {
      staticClass: "cards"
    }, [_c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "info"
    }, [_c('div', {
      staticClass: "left"
    }, [_c('div', {
      staticClass: "poster-holder"
    }, [_c('qrcode-vue', {
      attrs: {
        "value": card.number,
        "size": 180,
        "level": "H"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "right"
    }, [_c('h3', {
      staticClass: "card_heading"
    }, [_vm._v(_vm._s(_vm.$t("loyalty.card_name")) + " " + _vm._s(card.club === 1 ? _vm.$t("loyalty.card_type_employee") : ''))]), _vm._v(" "), _c('div', {
      staticClass: "ticket-body"
    }, [_c('div', {
      staticClass: "kvs"
    }, [_c('div', {
      staticClass: "kv"
    }, [_c('p', {
      staticClass: "key"
    }, [_vm._v(_vm._s(card.club === 1 ? _vm.$t("loyalty.remained_tickets") : _vm.$t("loyalty.remained_points")))]), _vm._v(" "), _c('p', {
      staticClass: "val"
    }, [_vm._v(_vm._s(_vm.getFreeTickets(card.name, _vm.recognitions)))])]), _vm._v(" "), _c('div', {
      staticClass: "kv"
    }, [_c('p', {
      staticClass: "key"
    }, [_vm._v(_vm._s(_vm.$t("loyalty.number_card")))]), _vm._v(" "), _c('p', {
      staticClass: "val"
    }, [_vm._v(_vm._s(card.number))])])])])])]), _vm._v(" "), _c('div', {
      staticClass: "rules",
      class: {
        'open': card.isShowRules
      },
      on: {
        "click": function($event) {
          return _vm.onShowRules(cardIndex)
        }
      }
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "vis"
    }, [_c('div', {
      staticClass: "descr"
    }, [(card.name === 'HO') ? _c('ho-rules') : _vm._e(), _vm._v(" "), (card.name === 'line') ? _c('line-rules') : _vm._e(), _vm._v(" "), (card.name === 'MFriends') ? _c('m-friends-rules') : _vm._e()], 1)])])])]) : _vm._e()])
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Правила:")])]), _vm._v(" "), _c('div', {
    staticClass: "det_pic"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f48df7b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/loyalty/loyalty.vue
// module id = 412
// module chunks = 1